'use client';
const MANIFEST_STYLES = {
    utility: {
        hashed: 'utility.c6df987ca5ca6a2219495c5968a84b95.min.css',
        versioned: 'utility.min.css'
    },
    core: {
        hashed: 'core.f4df0dec631cbddf4528890fbe4caf05.min.css',
        versioned: 'core.min.css'
    },
    zoomControls: {
        hashed: 'zoom-controls.fdebf98ea6c52ec9cafb7da5f47e6184.min.css',
        versioned: 'zoom-controls.min.css'
    },
    visible: {
        hashed: 'visible.388bb400607befa65ff09c5a81d28b7f.min.css',
        versioned: 'visible.min.css'
    },
    toggleSwitch: {
        hashed: 'toggle-switch.df5e38e6f211fc797523abfd0c423fcd.min.css',
        versioned: 'toggle-switch.min.css'
    },
    thumbnailsHero: {
        hashed: 'thumbnails-hero.7b3fa59f58da180add3cd7bf3c5913d8.min.css',
        versioned: 'thumbnails-hero.min.css'
    },
    tabs: {
        hashed: 'tabs.4ff1c0c5f8adb8e868d9f3888b2e0acb.min.css',
        versioned: 'tabs.min.css'
    },
    table: {
        hashed: 'table.4e52d9069a843e8ca01301fc7f341565.min.css',
        versioned: 'table.min.css'
    },
    stepIndicator: {
        hashed: 'step-indicator.88681be33f34984f8c3e69c15f6b9a54.min.css',
        versioned: 'step-indicator.min.css'
    },
    statusMessage: {
        hashed: 'status-message.5a5dae6bd07da8296f6aedf3d0beb7aa.min.css',
        versioned: 'status-message.min.css'
    },
    standardTile: {
        hashed: 'standard-tile.ba88f90b2f9704ba4f2a7b5dd8220600.min.css',
        versioned: 'standard-tile.min.css'
    },
    spinner: {
        hashed: 'spinner.e28c0ae32bd5b461b339d7683cf90c86.min.css',
        versioned: 'spinner.min.css'
    },
    selectionSet: {
        hashed: 'selection-set.3156ffad3fda635eac6100cd53b20d92.min.css',
        versioned: 'selection-set.min.css'
    },
    ratingsStars: {
        hashed: 'ratings-stars.e164eed6ff785abfb972c16df7ae04b5.min.css',
        versioned: 'ratings-stars.min.css'
    },
    progressiveImage: {
        hashed: 'progressive-image.f0a54c9123842f31dd3ce49ef0961118.min.css',
        versioned: 'progressive-image.min.css'
    },
    progressBar: {
        hashed: 'progress-bar.62a0f2a9125f6611361a9becb64edc21.min.css',
        versioned: 'progress-bar.min.css'
    },
    pricing: {
        hashed: 'pricing.d41d8cd98f00b204e9800998ecf8427e.min.css',
        versioned: 'pricing.min.css'
    },
    priceBar: {
        hashed: 'price-bar.079ed7a8b72a43c295d80b33bc4a20b3.min.css',
        versioned: 'price-bar.min.css'
    },
    popover: {
        hashed: 'popover.d783c1ed00a4d1ce89812ec8abdfefb9.min.css',
        versioned: 'popover.min.css'
    },
    pagination: {
        hashed: 'pagination.2c03191f280c81657b0f76510407d9c8.min.css',
        versioned: 'pagination.min.css'
    },
    modalDialog: {
        hashed: 'modal-dialog.df892413d24d60f8ceb8749ce8c4b7d5.min.css',
        versioned: 'modal-dialog.min.css'
    },
    listbox: {
        hashed: 'listbox.0bba66a9213f3542b8237d3b5f7eca23.min.css',
        versioned: 'listbox.min.css'
    },
    icon: {
        hashed: 'icon.d41d8cd98f00b204e9800998ecf8427e.min.css',
        versioned: 'icon.min.css'
    },
    hidden: {
        hashed: 'hidden.90549d732670d4ba02fac0dc001a0bb8.min.css',
        versioned: 'hidden.min.css'
    },
    grid: {
        hashed: 'grid.393ab9dc32ba1b6be15bf4d30fc3c6d6.min.css',
        versioned: 'grid.min.css'
    },
    fileTile: {
        hashed: 'file-tile.6aa7423a8addd0bd24dea78ede47326c.min.css',
        versioned: 'file-tile.min.css'
    },
    fileDropzone: {
        hashed: 'file-dropzone.8791a0f195bddf0b5fde79482b9d6426.min.css',
        versioned: 'file-dropzone.min.css'
    },
    fieldSet: {
        hashed: 'field-set.d41d8cd98f00b204e9800998ecf8427e.min.css',
        versioned: 'field-set.min.css'
    },
    emptyState: {
        hashed: 'empty-state.46e5c6ac5dc9486f3ced02f03841f060.min.css',
        versioned: 'empty-state.min.css'
    },
    carousel: {
        hashed: 'carousel.4c340bd4dba72abd9173c0dd4a9a672f.min.css',
        versioned: 'carousel.min.css'
    },
    button: {
        hashed: 'button.d41d8cd98f00b204e9800998ecf8427e.min.css',
        versioned: 'button.min.css'
    },
    baseTile: {
        hashed: 'base-tile.d84efe0bfc298013c3e8f48e4fdc4e2b.min.css',
        versioned: 'base-tile.min.css'
    },
    banner: {
        hashed: 'banner.b379ad4aa1604b7d8e4a0f09dcf926b1.min.css',
        versioned: 'banner.min.css'
    },
    avatar: {
        hashed: 'avatar.d67d114201fbc23f9ebe19c0ae0dd88d.min.css',
        versioned: 'avatar.min.css'
    },
    anchorBar: {
        hashed: 'anchor-bar.5b468b974d0b794a61530a5071a67467.min.css',
        versioned: 'anchor-bar.min.css'
    },
    alertBox: {
        hashed: 'alert-box.569877fe89ec1331a6c4d5f30ae3cbaf.min.css',
        versioned: 'alert-box.min.css'
    },
    accordion: {
        hashed: 'accordion.d0252b4f339023af750ed1b37747ae58.min.css',
        versioned: 'accordion.min.css'
    }
};

export { MANIFEST_STYLES };
